var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevLarge = function SvgPrevLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.47 6.137a.75.75 0 0 1 1.06 1.06L8.477 15.25h16.857a.75.75 0 0 1 0 1.5H8.477l8.053 8.054a.75.75 0 0 1-1.06 1.06L6.137 16.53a.748.748 0 0 1-.122-.167c-.015-.026-.03-.051-.042-.08-.005-.01-.007-.023-.011-.035A.744.744 0 0 1 5.917 16c0-.08.015-.158.04-.231.005-.017.008-.034.015-.051l.004-.01c.009-.021.02-.04.032-.061a.745.745 0 0 1 .129-.177l9.333-9.333Z",
    fill: "#A9B0B4"
  })));
};
export default SvgPrevLarge;